import { projectService } from '@/services'
import { nextIndex, generateHTML } from '@/core/helper-functions'
import router from '@/router'

export default {
  state: () => ({
    projects: [],
    trash: [],
    currentProject: null,
    deletedProjects: [],
    words: 0,
    characters: 0,
    share: null,
    size: 0,
    sizes: {},
    isTableActive: false
  }),

  mutations: {
    setProjects (state, value) {
      state.projects = value
    },

    setCurrentProject (state, value) {
      state.currentProject = value
    },

    setUpdatedAt (state) {
      state.currentProject.updatedAt = new Date()
    },

    clearProject (state) {
      state.currentProject = null
    },

    setDeletedProjects (state, value) {
      state.deletedProjects = value
    },

    setWordsCount (state, value) {
      state.words = value
    },

    setCharactersCount (state, value) {
      state.characters = value
    },

    setShare (state, value) {
      state.share = value
    },

    setTrashedProjects (state, value) {
      state.trash = value
    },

    updateComments (state, value) {
      state.currentProject.comments = value
    },

    setSize (state, value) {
      state.size = value
    },

    setSizes (state, value) {
      state.sizes = value
    },

    setTableActive (state, value) {
      state.isTableActive = value
    }
  },

  actions: {
    getProject ({ commit, dispatch }, id) {
      commit('toggleBookLoading', true)
      return projectService.getById(id)
        .then(({ data }) => {
          dispatch('getSize', id)
          commit('setCurrentProject', data)
          commit('toggleBookLoading', false)
          return Promise.resolve(data)
        })
    },

    getProjects ({ commit }) {
      projectService.getAll().then(({ data }) => {
        commit('setProjects', data.projects)
      })
    },

    getDeletedProjects ({ commit, getters }) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      commit('loading', true)
      projectService.getDeleted().then(({ data }) => {
        commit('setTrashedProjects', data.projects)
        commit('setSizes', data.sizes)
      })
    },

    addProject ({ dispatch, rootState, commit, getters }, parentId = null) {
      if (getters.allowAddProject) {
        commit('toggleBookLoading', true)
        const settings = rootState.settings.settings
        const projectTitle = `Page ${nextIndex(rootState.book.book.projects, 'Page', ' ')}`
        projectService.add({
          bookId: rootState.book.book.id,
          title: projectTitle,
          icon: rootState.settings.defaultProjectIcon || 'purple_circle',
          parentId,
          body: '<h1></h1>',
          html: generateHTML('<h1></h1>', settings, projectTitle)
        }).then(_ => {
          dispatch('getBook', rootState.book.book.id)
            .then((data) => {
              const project = data.projects.find(item => item.title === projectTitle)
              if (project) {
                router.replace({ query: { page: project.id } })
              }
            })
          dispatch('stats')
        })
      } else {
        commit('toggleLimitModal', { show: true, type: 'Pages' })
      }
    },

    deleteProject ({ dispatch, rootState, commit, state }, id) {
      if (rootState.book.book.projects.length <= 1) {
        commit('setNotification', { isVisible: true, message: 'Cannot delete last page', color: 'error' })
        return
      }

      commit('toggleBookLoading', true)
      return projectService.delete(id).then(async _ => {
        const deletedProjects = state.deletedProjects

        Promise.all([
          dispatch('stats'),
          dispatch('getBook', rootState.book.book.id)
        ]).then(_ => {
          deletedProjects.push(id)
          commit('setDeletedProjects', deletedProjects)
          if (state.currentProject.id === id) {
            router.replace({ query: { page: rootState.book.book.projects[0].id } })
          }

          commit('toggleBookLoading', false)
        })
      })
    },

    editProject ({ commit, state }, value) {
      const project = state.currentProject

      if (value.id === project.id) {
        commit('setUpdatedAt')
      }

      return projectService.edit(value.id, value.data)
    },

    restoreProject ({ dispatch, rootState, commit, getters }, id) {
      if (getters.isTrialOver) return Promise.reject(new Error('Trial is off'))

      if (getters.allowAddProject) {
        return projectService.restore(id).then(_ => {
          if (rootState.book.book) {
            dispatch('getBook', rootState.book.book.id)
            router.replace({ query: { page: id } }).catch(() => {})
          }

          return Promise.resolve()
        })
      } else {
        commit('loading', false)
        commit('toggleLimitModal', { show: true, type: 'Pages' })
      }
    },

    getShare ({ commit }, id) {
      return projectService.getShareByProjectId(id).then(({ data }) => {
        commit('setShare', data)
        return data
      })
    },

    getSize ({ commit }, id) {
      return projectService.getSize(id).then(({ data }) => {
        commit('setSize', data.size)
      })
    },

    getSizeOfSharedProject ({ commit, state }, id) {
      return projectService.getSizeOfSharedProject(id, state.share.id).then(({ data }) => {
        commit('setSize', data.size)
      })
    }
  }
}
